import { PlugZapIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/** Shown wherever a payment action would be: the catalog stays browsable, actions are disabled. */
export function NotConfiguredNotice({
	compact,
	className,
}: {
	compact?: boolean;
	className?: string;
}) {
	return (
		<div
			className={cn(
				"crop-marks relative flex items-start gap-3 rounded-lg border border-dashed bg-card px-4 py-3",
				className,
			)}
		>
			<div className="bg-dot-grid pointer-events-none absolute inset-0 rounded-lg opacity-40" />
			<PlugZapIcon className="relative mt-0.5 size-4 shrink-0 text-muted-foreground" />
			<div className="relative flex flex-col gap-0.5">
				<span className="mono-label">Payments · not connected</span>
				<p className="text-[13px] font-medium">Billing isn't configured yet</p>
				{!compact && (
					<p className="text-[12.5px] text-muted-foreground">
						Plans, usage and the credit ledger work as normal. Upgrades, credit packs, invoices and
						auto top-up unlock once payments are connected.
					</p>
				)}
			</div>
		</div>
	);
}
